// src/utils/fontStyles.js

export const fontStyles = [
   //{ font: "Caveat", size: 12, color: "darkorange", fontWeight: "normal" },
  //{ font: "DancingScript", size: 11, color: "dodgerblue", fontWeight: "normal" },
  //{ font: "Dosis", size: 11, color: "forestgreen", fontWeight: "normal" },
  //{ font: "IndieFlower", size: 11, color: "hotpink", fontWeight: "normal" },
  //{ font: "Quicksand", size: 9.0, color: "#FFD700", fontWeight: "normal" },
  //{ font: "NiconneRegular", size: 11, color: "#FFD700", fontWeight: "normal" },
  //{ font: "MountainsofChristmas", size: 10.6, color: "dodgerblue", fontWeight: "normal" },
  //{ font: "IndieFlower", size: 11, color: "hotpink", fontWeight: "normal" },
  //{ font: "CalligraffittiRegular", size: 9.0, color: "#FFD700", fontWeight: "normal" },
  //{ font: "OoohBabyRegular", size: 11.0, color: "#FFD700", fontWeight: "normal" },
  //{ font: "NoricanRegular", size: 11.0, color: "#FFD700", fontWeight: "normal" },  
  
  { font: "Caveat", size: 13, color: "darkorange", fontWeight: "normal" },
  { font: "CookieRegular", size: 13.0, color: "#FFD700", fontWeight: "normal" },
  //{ font: "Arizonia", size: 10.6, color: "#FFD700", fontWeight: "normal" },
  { font: "DancingScript", size: 12.2, color: "dodgerblue", fontWeight: "normal" },
  { font: "PlayballRegular", size: 11.0, color: "#FFD700", fontWeight: "normal" },
  //{ font: "Dosis", size: 10.8, color: "forestgreen", fontWeight: "normal" },
  { font: "QwigleyRegular", size: 15, color: "dodgerblue", fontWeight: "normal" },
  { font: "Quicksand", size: 9.0, color: "#FFD700", fontWeight: "normal" },
  
  
];

// Optionally export separate color sets (if used across components)
export const labelColors = ["#191970", "#D35400", "#800080", "#006400", "#C71585"];
export const valueColors = ["#800080", "#006400", "#00008B", "#DC143C", "darkviolet"];
export const lineColors = ["#228B22", "#FF1493", "#FFBF00", "#4682B4", "#D2691E"];

// ================= SCHOOL NAME COLOR OPTIONS (UI FRIENDLY) =================
// Uses EXISTING labelColors only (no new colors introduced)

export const SCHOOL_NAME_COLORS = [
  { name: 'Midnight Blue', value: '#191970' },
  { name: 'Orange', value: '#D35400' },
  { name: 'Purple', value: '#800080' },
  { name: 'Dark Green', value: '#006400' },
  { name: 'Pink', value: '#C71585' },
];
